import { makeStyles } from "@material-ui/core/styles";

const useStyles = makeStyles(theme => ({
  lockup_container: {
    backgroundColor: theme.palette.primary.light,
    color: 'white',
    borderRadius: '10px',
    padding: '10px 12px',
    width: '140px',
    height: '80px',
    display: "flex",
    flexDirection: "column",
    justifyContent: "space-between",
    boxSizing: 'border-box',
  },
  header: {
    display: 'flex',
    alignItems: 'center',
    gap: '4px',
    fontSize: '12px',
    fontWeight: 500,
  },
  icon: {
    fontSize: '16px',
  },
  label: {
    fontSize: '12px',
    textTransform: 'uppercase',
  },
  weight: {
    fontSize: '18px',
    fontWeight: 'bold',
    lineHeight: '20px',
  },
  orders: {
    fontSize: '12px',
  }
}));

export { useStyles };
